import css from 'styled-jsx/css';

export default css`:global(.Modal) {
  position: fixed;
  height: 0;
  overflow: hidden;
  left: 50%;
  margin-left: -200px;
  max-width: 400px;
  width: 100%;
  bottom: 0;
  text-align: center;
  opacity: 0;
  visibility: hidden;
  color: #666;
  background-color: #efefef;
  transform: translateX(0%) translateY(120%);
  -webkit-transform: translateX(0%) translateY(120%);
  -moz-transform: translateX(0%) translateY(120%);
  -ms-transform: translateX(0%) translateY(120%);
  -o-transform: translateX(0%) translateY(120%);
  -webkit-border-top-left-radius: 8px;
  -webkit-border-top-right-radius: 8px;
  -moz-border-radius-topleft: 8px;
  -moz-border-radius-topright: 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  -webkit-box-shadow: 0 6px 15px rgba(36, 37, 38, 0.08);
  -moz-box-shadow: 0 6px 15px rgba(36, 37, 38, 0.08);
  box-shadow: 0 6px 15px rgba(36, 37, 38, 0.08);
  z-index: 1050;
  transition: all 0.3s; }

@media only screen and (max-width: 400px) {
  :global(.Modal) {
    left: 0;
    margin-left: 0; } }

:global(.ReactModal__Content--after-open.Modal) {
  height: auto;
  overflow: auto;
  transition: all 0.3s;
  transform: translateX(0%) translateY(0%);
  opacity: 1;
  visibility: visible; }

:global(.ReactModal__Content--before-close.Modal) {
  opacity: 0; }

:global(.ReactModal__Modal) {
  position: absolute;
  top: 40px;
  left: 40px;
  right: 40px;
  bottom: 40px;
  background-color: papayawhip; }

:global(.Overlay) {
  visibility: visible;
  background-color: rgba(0, 0, 0, 0);
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 1051;
  transition: background-color 300ms;
  -webkit-transition: background-color 300ms;
  -ms-transition: background-color 300ms; }

:global(.ReactModal__Overlay--after-open) {
  background-color: rgba(0, 0, 0, 0.5); }

:global(.ReactModal__Overlay--before-close) {
  background-color: rgba(0, 0, 0, 0); }

:global(.ReactModal__Html--open) {
  overflow: hidden; }

:global(.ReactModal__Body--open) {
  overflow: hidden; }

.popSlidein__content {
  padding: 0 10px;
  padding-top: 5px;
  border-bottom: 1px solid #e3e3e3; }
  .popSlidein__content .popSlidein__title {
    margin: 5px auto;
    text-align: center;
    color: #333;
    letter-spacing: 1px;
    font-weight: bold;
    font-size: 0.9rem; }
  .popSlidein__content .popSlidein__line {
    display: block;
    border-bottom: #e1e1e1 solid 1px;
    margin: 3px auto; }
  .popSlidein__content.popSlidein__content--info .popSlidein__timetable {
    margin: 10px auto;
    line-height: 2em; }
    .popSlidein__content.popSlidein__content--info .popSlidein__timetable .--active {
      color: #838eff; }

button {
  color: #fff;
  border: none;
  outline: 0;
  background: #7d7af4;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  font-size: 1em; }
  button.full-width {
    display: block;
    width: calc(100% - 24px);
    margin: 12px auto 45px;
    height: 2.2em;
    padding: 0.4em 0;
    margin-bottom: 110px; }

.popSlidein__socialIcons,
.popSlidein__actionIcons {
  display: flex;
  overflow-x: scroll; }

.popSlidein__socialIcon,
.popSlidein__actionIcon {
  margin: 12px 7px;
  text-align: center; }
  .popSlidein__socialIcon span,
  .popSlidein__actionIcon span {
    display: block;
    font-size: 0.7rem;
    font-weight: 400;
    color: #333; }
  .popSlidein__socialIcon:before,
  .popSlidein__actionIcon:before {
    margin-bottom: 8px;
    width: 62px;
    height: 62px; }

.popSlidein__wrapper .btn.cancel {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-bottom: calc(20px + constant(safe-area-inset-bottom));
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
  letter-spacing: 2px;
  font-size: 1rem;
  font-weight: normal;
  text-align: center;
  background-color: #fff;
  cursor: pointer; }

.popSlidein__wrapper .btn.cancel:after {
  content: attr(data-btn-text); }
`